<template>
<DialogBox title="Sort Items" :settings="settings" @show="initialise">
    <draggable style="width:100%" v-model="localItems" :options="{ animation: 350, group:'items', xxxhandle: '.draggable-handle'}" @end="afterDrag">
        <div v-for="item in localItems" :key="item.meta.key" class="list-tile clickable hoverable" :data-order="item.order" @click="itemClicked(item)">
            <div style="float:right;margin-top:-2px;margin-right:-15px" @click.stop>
                <v-menu offset-y left>
                    <template v-slot:activator="{ on }">
                    <v-icon v-on="on" class="draggable-handle" style="color:#ddd">more_vert</v-icon>
                    </template>
                    <v-list>
                        <v-list-item @click="editItem(item)">
                            <v-list-item-title>Edit</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="addItem">
                            <v-list-item-title>Add New</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
            <slot v-bind="item">    
                 {{item.name}}
            </slot>
        </div>   
    </draggable>
</DialogBox>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import draggable from 'vuedraggable'
import NiceData from '../data/NiceData';
import OrderHelpers from '../helpers/OrderHelpers'
import DialogBox from '../ui-elements/DialogBox'
import ElementsStore from '../store/ElementsStore';

export default {
    data() {
        return {
            localItems: []
        }
    },
    components: {
        draggable,
        DialogBox,
    },
    
    props: {
        dataRef: Object,
        settings: Object,
        items: Array,
    },

    computed: {

    },

    methods: {
        afterDrag(e) {
            console.log('dragged', e)
            let newItem = this.localItems[e.newIndex]
            newItem.order = OrderHelpers.getAverageOrder(e)
            NiceData.saveItem(newItem)
        },
        editItem(item) {
            this.editDialog.item = {...item}
            this.editDialog.settings.visible = true
        },
        addItem() {
            let item = {
                meta: {
                    key: DataHelpers.getKey(),
                    path: this.dataRef.toString().split('/').splice(3).join('/'),
                    savePosition: 'top'
                }
            }
            this.editItem(item)
    
        },
        saveRecord(record) {
            NiceData.saveItem(record)
        },

        deleteRecord(record) {
            NiceData.deleteItem(record)
            this.editDialog.settings.visible = false
        },

        itemClicked(item) {
            this.$emit('click', item)
        },

        initialise() {
            if(!this.dataRef && !this.items)
                return
            else if(this.items)
                this.localItems = this.items
            else
                this.dataRef.orderByChild('order').on('value', snap => {
                    this.localItems = NiceData.arrayFromSnapshot(snap)
                })
        }
    },

    created() {
    
    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// SortDialog.vue?3818bbf0